import { getCreatePageState } from '../utils';

export const selectCreateStep = (state) => getCreatePageState(state).step;
